<template>
  <div class="advices">
    <p class="h2 text-center mt-sm-4 mt-md-5 mt-4 mb-2">{{ $t($route.params.step.replace(/-/g,"_")) }}</p>
    <hr class="underline mb-1 mb-sm-1 mb-lg-2">
    <div class="d-flex mr-2 ml-2 mb-2 mt-3">
      <router-link class="mt-auto mb-auto mr-auto" :to="`/${$route.params.locale}/${advices.back}`"><button type="button" class="btn btn-outline-primary back-button"><font-awesome-icon icon="chevron-left" class="mr-2" />{{ $t('back_button') }}</button></router-link>
      <button class="btn btn-primary ml-auto" :disabled="loading == true" @click="imprimir">
        <div v-if="loading" class="spinner-border mr-2" role="status" style="width: 20px; height: 20px; vertical-align: -0.3rem; border-width: 2px;">
          <span class="sr-only">Loading...</span>
        </div>
        <font-awesome-icon v-else icon="file-download" class="mr-2" style="width: 20px; height: 20px; vertical-align: -0.3rem;" />{{ $t('download_pdf') }}
      </button>
    </div>
    <div class="stories p-3 p-sm-4 p-lg-5">
      <div v-for="specific in advices.specific" :key="specific.title" class="advices__specific">
        <p class="advices__specific-title text-center">{{ $t(specific.title) }}</p>
        <div v-for="advice in specific.list" :key="advice" class="advice d-flex pl-4 pr-4">
          <font-awesome-icon icon="check-circle" />
          <p class="advice-text" v-html="$t(advice)"></p>
        </div>
        <div class="advices__specific__remember pl-4 pr-4" v-if="specific.remember">
          <p class="advices__specific__remember-title">{{ $t('remember_title') }}</p>
          <div v-for="adviceRemember in specific.remember" :key="adviceRemember" class="advice d-flex">
            <font-awesome-icon icon="check-circle" />
            <p class="advice-text" v-html="$t(adviceRemember)"></p>
          </div>
        </div>
      </div>
      <div class="advices__general">
        <p class="advices__general-title text-center">{{ $t(advices.general.title) }}</p>
        <div v-for="section in advices.general.sections" :key="section.title" class="advices__general__section pl-4 pr-4">
          <p class="advices__general__section-title">{{ $t(section.title) }}</p>
          <div v-for="advice in section.list" :key="advice" class="advice d-flex">
            <font-awesome-icon icon="check-circle" />
            <p class="advice-text" v-html="$t(advice)"></p>
          </div>
        </div>
      </div>
      <p class="text-secondary mt-4 mb-0">{{ $t('home_note1') }}</p>
    </div>
    <div class="m-2 p-5 pdf-content" style="display:none;position:absolute;top:-10000px;width:950px">
      <img src="@/assets/logo.jpg" alt="Logo ecom4children" width="180">
      <p class="h2 text-center mt-3 mb-2">{{ $t($route.params.step.replace(/-/g,"_")) }}</p>
      <hr class="underline mb-4">
      <div class="pdf-specific">
        <div v-for="specific in advices.specific" :key="specific.title" class="advices__specific">
          <p class="advices__specific-title text-center">{{ $t(specific.title) }}</p>
          <div v-for="advice in specific.list" :key="advice" class="advice d-flex pl-4 pr-4">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t(advice)"></p>
          </div>
          <div class="advices__specific__remember pl-4 pr-4" v-if="specific.remember">
            <p class="advices__specific__remember-title">{{ $t('remember_title') }}</p>
            <div v-for="adviceRemember in specific.remember" :key="adviceRemember" class="advice d-flex">
              <font-awesome-icon icon="check-circle" />
              <p v-html="$t(adviceRemember)"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="advices__general">
        <p class="advices__general-title text-center">{{ $t(advices.general.title) }}</p>
        <div v-for="section in advices.general.sections" :key="section.title" class="advices__general__section pl-4 pr-4">
          <p class="advices__general__section-title">{{ $t(section.title) }}</p>
          <div v-for="advice in section.list" :key="advice" class="advice d-flex">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t(advice)"></p>
          </div>
        </div>
      </div>
      <p class="text-secondary mt-4 mb-4">{{ $t('home_note1') }}</p>
      <footer>
        <div class="info">
          <p class="m-0">
            {{ $t('home_note2') }}
            <a href="https://www.ecom4children.eu/" target="blank">ecom4children.eu</a>.
          </p>
          <p class="mt-1 mb-2" v-html="$t('cc_message')"></p>
          <img src="@/assets/by-nc-nd.png" alt="Creative commons license" style="height:30px !important"/>
        </div>
        <div class="disclaimer">
          <div class="col-12 col-md-4 d-flex"><img class="mt-auto mb-auto ml-auto" :src="require('@/assets/commision-'+$route.params.locale+'.jpg')"></div>
          <p class="col-12 col-md-8 text-left" v-html="$t('disclaimer_text')"></p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import VIGNETTES from '@/vignettes';
import ADVICES from '@/advices';

import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  name: 'advices',
  data() {
    return {
        vignettes: VIGNETTES[this.$route.params.step],
        advices: ADVICES[this.$route.params.step],
        loading: false
    }
  },
  methods: {
    getImage(path) {
      return require('@/assets/'+path)
    },
    imprimir() {
      if (this.loading == false) {
        console.log(this.loading, 'dentro');
        this.loading = true;
        var elem = document.getElementsByClassName('pdf-content')[0];
        elem.style.display = "block";
        html2canvas(elem).then(canvas => {
          elem.style.display = "none";
          var imgData = canvas.toDataURL('image/png');
          var imgWidth = 210; 
          var pageHeight = 295;  
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
          var doc = new jsPDF('p', 'mm');
          var position = 0;

          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          this.loading = false;
          doc.save(`${this.$t(this.$route.params.step.replace(/-/g,"_"))}.pdf`);
        });
      }

    // var doc = new jsPDF();

    // doc.fromHTML(elem, 15, 15, {
    //     'width': 170
    // });
    // doc.save('sample-file.pdf');

    // doc = new jsPDF();

    // doc.html(elem, {
    //   html2canvas: {
    //       'width': 200
    //   },
    //   callback: (doc) => {
    //               doc.save(`${this.$t(this.$route.params.step.replace(/-/g,"_"))}.pdf`);
    //   }
    // });

    // doc = new jsPDF();
    // doc.html(elem, {
		// 	callback: (doc) => {
    //     doc.save(`${this.$t(this.$route.params.step.replace(/-/g,"_"))}.pdf`);
    //   }});
    // }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

.advices {
    max-width: 1000px;
    margin: auto;
    p.h2 {
        font-family: 'Kalam', sans-serif;
        text-transform: uppercase;
    }
    .underline {
        margin: 0 auto;
        border-width: 2px;
        max-width: 400px;
        border-color: #e31b18;
        margin-bottom: 25px;
    }
    .stories {
      background-color: white;
      border: solid black;
      border-width: 3px 4px 3px 4px;
      border-radius:60% 1% 20% 1%/0.3% 20% 1% 20%;
      overflow: hidden;
      .advice {
        margin-bottom: 15px;
        text-align: justify;
        svg {
          color: #4caf50;
          font-size: 1.5rem;
          margin: auto 0;
          margin-right: 10px;
        }
        p {
          font-size: 1.05rem;
          margin: auto 0;
          font-family: "Architects Daughter", "Comic Sans MS";
        }
      }
    }
    &__general, &__specific {
      background-color: #ace8dc44;
      border-right: 1px solid #ace8dc;
      border-left: 1px solid #ace8dc;
      margin-bottom: 25px;
      &-title {
        text-transform: uppercase;
        font-size: 1.4rem;
        padding: 10px 15px;
        padding-top: 18px;
        font-family: 'Kalam', sans-serif;
        background-color: #ace8dc;
        line-height: 1.9rem;
        // border-bottom: 1px solid #ace8dc;
      }
      &__section {
        border-bottom: 1px solid #ace8dc;
        &-title {
          margin-top: 20px;
          font-size: 1.15rem;
          font-family: 'Kalam', sans-serif;
          letter-spacing: 0.01rem;
          background: #ace8dc66;
          padding: 5px;
          padding-top: 9px;
          padding-left: 15px;
        }
      }
    }

    &__specific {
      background-color: #ddc4e744;
      border-right: 1px solid #ddc4e7;
      border-left: 1px solid #ddc4e7;
      border-bottom: 1px solid #ddc4e7;
      &-title {
        background-color: #ddc4e7;
      }
      &__remember {
        border-top: 1px solid #ddc4e7;
        &-title {
          margin-top: 20px;
          font-size: 1.15rem;
          font-family: 'Kalam', sans-serif;
          letter-spacing: 0.01rem;
          background: #ddc4e759;
          padding: 5px;
          padding-top: 9px;
          padding-left: 15px;
        }
      }
      &:nth-child(2) {
        background-color: #f5d2ad44;
        border-right: 1px solid #f5d2ad;
        border-left: 1px solid #f5d2ad;
        border-bottom: 1px solid #f5d2ad;
        .advices__specific-title {
          background-color: #f5d2ad;
        }
        .advices__specific__remember {
          border-top: 1px solid #f5d2ad;
          &-title {
            background: #f5d2ad59;
          }
        }
      }
      &:nth-child(3) {
        background-color: #b7dbf244;
        border-right: 1px solid #b7dbf2;
        border-left: 1px solid #b7dbf2;
        border-bottom: 1px solid #b7dbf2;
        .advices__specific-title {
          background-color: #b7dbf2;
        }
        .advices__specific__remember {
          border-top: 1px solid #b7dbf2;
          &-title {
            background: #b7dbf259;
          }
        }
      }
      &:nth-child(4) {
        background-color: #faeba644;
        border-right: 1px solid #faeba6;
        border-left: 1px solid #faeba6;
        border-bottom: 1px solid #faeba6;
        .advices__specific-title {
          background-color: #faeba6;
        }
        .advices__specific__remember {
          border-top: 1px solid #faeba6;
          &-title {
            background: #faeba677;
          }
        }
      }
    }
    .pdf-content {
      .pdf-specific {
        .advices__specific {
          background-color: #ddc4e744;
          border-right: 1px solid #ddc4e7;
          border-left: 1px solid #ddc4e7;
          border-bottom: 1px solid #ddc4e7;
          &-title {
            background-color: #ddc4e7;
          }
          &__remember {
            border-top: 1px solid #ddc4e7;
            &-title {
              background: #ddc4e759;
            }
          }
          &:nth-child(2) {
            background-color: #f5d2ad44;
            border-right: 1px solid #f5d2ad;
            border-left: 1px solid #f5d2ad;
            border-bottom: 1px solid #f5d2ad;
            .advices__specific-title {
              background-color: #f5d2ad;
            }
            .advices__specific__remember {
              border-top: 1px solid #f5d2ad;
              &-title {
                background: #f5d2ad59;
              }
            }
          }
          &:nth-child(3) {
            background-color: #b7dbf244;
            border-right: 1px solid #b7dbf2;
            border-left: 1px solid #b7dbf2;
            border-bottom: 1px solid #b7dbf2;
            .advices__specific-title {
              background-color: #b7dbf2;
            }
            .advices__specific__remember {
              border-top: 1px solid #b7dbf2;
              &-title {
                background: #b7dbf259;
              }
            }
          }
          &:nth-child(4) {
            background-color: #faeba644;
            border-right: 1px solid #faeba6;
            border-left: 1px solid #faeba6;
            border-bottom: 1px solid #faeba6;
            .advices__specific-title {
              background-color: #faeba6;
            }
            .advices__specific__remember {
              border-top: 1px solid #faeba6;
              &-title {
                background: #faeba677;
              }
            }
          }
        }
      }
    }
  }
</style>

